import _       from 'lodash';
import request from 'request-promise';

import { NotFoundError, BadRequestError, ForbiddenError, PreconditionFailed } from 'lib/errors';
export { NotFoundError, BadRequestError, ForbiddenError, PreconditionFailed };

export default class Backend {
  static forceLogging = false;

  static request(method, url, options = {}, resourceName = 'resource', logging = false) {
    const requestor = options.requestor ?? request;

    options = { json: true, ..._.omit(options, ['requestor']), uri: url, method };

    if (logging || this.forceLogging) {
      console.log(`${method} ${url}`);
      console.log(JSON.stringify(options));
    }

    return requestor(options).catch(response => this._failureProcessor(response, resourceName));
  }

  static requestWithAuth(authToken, method, url, options = {}, resourceName = 'resource', logging = false) {
    options.headers                  = options.headers ?? {};
    options.headers['Authorization'] = `Token ${authToken}`;

    return this.request(method, url, options, resourceName, logging);
  }

  // TODO: replace this using request qs option
  static pairsToParams(pairs) {
    return pairs.map(pair => pair.join('=')).join('&');
  }

  static withParams(url, ...params) {
    const joined = _.concat(...params);

    return joined.length ? url + '?' + this.pairsToParams(joined) : url;
  }

  static _failureProcessor(response, resourceName) {
    if (response.statusCode === 400) {
      throw new BadRequestError(response.error);
    }
    if (response.statusCode === 403) {
      throw new ForbiddenError(response.error);
    }
    if (response.statusCode === 404) {
      throw new NotFoundError(resourceName);
    }
    if (response.statusCode === 412) {
      throw new PreconditionFailed(response.error);
    } else {
      throw response;
    }
  }

  // expects auth to have .token attribute/property
  constructor(baseUrl, auth, requestor = request) {
    this.baseUrl = baseUrl;
    this.auth = auth;
    this.requestor = requestor;
  }

  urlFor(path, params = {}) {
    if (_.isPlainObject(params)) { params = _.toPairs(params); }

    return this.constructor.withParams(this.baseUrl + path, params);
  }

  request(method, path, options = {}, ...args) {
    options = { requestor: this.requestor, ...options };

    return this.constructor.request(method, this.urlFor(path), options, ...args);
  }

  requestWithAuth(method, path, options = {}, ...args) {
    options = { requestor: this.requestor, ...options };

    return this.constructor.requestWithAuth(this.auth.token, method, this.urlFor(path), options, ...args);
  }

  requestWithToken(token, method, path, options = {}, ...args) {
    options = { requestor: this.requestor, ...options };

    return this.constructor.requestWithAuth(token, method, this.urlFor(path), options, ...args);
  }
};
